import { useSectionView, type SectionId } from '@/components/feature/SectionViewProvider';

const sectionLinks: { label: string; sectionId: SectionId }[] = [
  { label: 'Our Services', sectionId: 'services' },
  { label: 'Testimonials', sectionId: 'testimonials' },
  { label: 'Contact Us', sectionId: 'contact' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { goToSection, openDoc } = useSectionView();

  return (
    <footer id="site-footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-6 md:px-12 lg:px-16 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 justify-between">
          {/* Brand */}
          <div className="max-w-sm">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex items-center gap-1.5 mb-4 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center overflow-hidden rounded-md -translate-x-4 md:-translate-x-1.5">
                <img
                  src="/assets/logo.png"
                  alt="SettleSpace"
                  className="w-full h-full object-contain"
                />
              </div>
              <img
                src="/assets/wordmark.png"
                alt="SettleSpace"
                className="h-9 w-auto object-contain -ml-8 md:-ml-3 opacity-80 md:opacity-100"
              />
            </button>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Don&apos;t worry, we&apos;ll help you settle into your space.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-10 md:gap-16">
            {/* Company */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                Company
              </h4>
              <ul className="flex flex-col gap-2">
                {sectionLinks.map((link) => (
                  <li key={link.sectionId}>
                    <button
                      onClick={() => goToSection(link.sectionId)}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                Support
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <button
                    type="button"
                    onClick={() => openDoc('help')}
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    Help Center
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => openDoc('privacy')}
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    Privacy Policy
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => openDoc('terms')}
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    Terms of Service
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            {currentYear} SettleSpace. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://share.google/d6ECZUXzldY9v8z8y"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 hover:bg-background-300/60 hover:scale-110 transition-all duration-200 cursor-pointer"
              aria-label="Google"
            >
              <i className="ri-google-fill text-sm text-foreground-700" />
            </a>
            <a
              href="https://www.instagram.com/settlespacein/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 hover:bg-background-300/60 hover:scale-110 transition-all duration-200 cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-fill text-sm text-foreground-700" />
            </a>
            <a
              href="https://www.linkedin.com/company/settlespace/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 hover:bg-background-300/60 hover:scale-110 transition-all duration-200 cursor-pointer"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-sm text-foreground-700" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}